"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var texts = {
    trimming: function () { return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h1', appendClassname: 'mb-4' }, "Inkorten"),
        react_1.default.createElement(storybook_1.Texts.Primary, null, "Sleep de balk naast dit icon naar de gewenste lengte om de video te trimmen. Klik daarna op \u201Cinkorten\u201D.")); },
    cards: function () { return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h1', appendClassname: 'mb-4' }, "Cards"),
        react_1.default.createElement(storybook_1.Texts.Primary, { appendClassname: 'mb-2' }, "Kaarten zijn meldingen met een vaste indeling die worden weergeven op desktop-pc's en mobiele apparaten en die je kunt instellen om je club, sponsoren en andere video's op je kanaal te promoten."),
        react_1.default.createElement(storybook_1.Texts.Primary, null, "Nadat je ze hebt ingesteld, wordt er op het gekozen moment een rechthoekig vakje (een teaser) in de rechterbovenhoek van de video weergegeven.")); },
    chapters: function () { return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h1', appendClassname: 'mb-4' }, "Hoofdstukken"),
        react_1.default.createElement(storybook_1.Texts.Primary, null, "Wanneer je een hoofdstuk toevoegd verschijnt deze op de tijdlijn van je video, je fans kunnen zo eenvoudig door de video navigeren.")); },
};
function TrackInfo(_a) {
    var type = _a.type;
    var text = texts[type];
    return react_1.default.createElement("div", null, text());
}
function TrackLegend(_a) {
    var type = _a.type, icon = _a.icon, setModal = _a.setModal;
    return react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return setModal({
            content: function () { return react_1.default.createElement(TrackInfo, { type: type }); },
        }); }, className: 'storybook-timelines-track-legend' },
        react_1.default.createElement(storybook_1.Icons.Icon, { name: icon, className: 'w-6' }));
}
exports.default = TrackLegend;
